import React from "react";


import "./App.css";
import "../src/css/common/NavTop.css";
import "../src/css/common/Navbar.css";
import "../src/css/common/SmallNavbar.css";
import "../src/css/common/Animation.css";
import "../src/css/common/AboutCompany.css";
import "../src/css/common/PopularServices.css";
import "../src/css/common/BookingForm.css";
import "../src/css/common/RecentProjects.css";
import "../src/css/common/BrandsSlider.css";
import "../src/css/common/TestimonialComponent.css";
import "../src/css/common/OurPrice.css";
import "../src/css/common/OurPriceViewDetails.css";
import "../src/css/common/WhyUs.css";
import "../src/css/common/Faqs.css";
import "../src/css/common/AmcCompare.css";
import "../src/css/common/CoverageDetails.css";
import "../src/css/common/WAFixButton.css";
import "../src/css/common/Footer.css";
import "../src/css/common/ThanksComponent.css";
import "../src/css/common/ServiceBrand.css";
import "../src/css/common/AlertMessage.css";
import "../src/css/common/ContactFixButton.css";
import "../src/css/common/PrivacyPolicyComponent.css";
import "../src/css/common/ContactButton.css";
import "../src/css/home/HomeNav.css";
import "../src/css/home/HomePage.css";
import "../src/css/home/HomeHeader.css";
import "../src/css/home/LandingHeader.css";
import "../src/css/common/RateCardPage.css";
import "../src/css/common/CartComponent.css";
import "../src/css/common/CardBookingForm.css"
import "./css/common/CustomerFeedback.css"
import "./css/others/PrivacyPolicy.css"


import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ThanksPage from "./pages/ThanksPage";
import ScrollToTop from "./components/others/ScrollToTop";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import BrandSlider from "./components/common/BrandSlider";
import OtherComponent from "./components/others/OtherComponent";
import RateCardPage from "./pages/RateCardPage";
import CartComponent from "./components/cart/CartComponent";
import CardBookingForm from "./components/cart/CardBookingForm";
import AppPoliccy from "./components/others/AppPoliccy";
import AppTermCondition from "./components/others/AppTermCondition";

const App = () => {
  return (
    <div>
      <BrowserRouter>
      <ScrollToTop/>
          <CartComponent />
        <Routes>

          
          <Route path="/" element={<HomePage />} />
          <Route path="/thank-you" element={<ThanksPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          {/* <Route path="/card-booking-form" element={<CardBookingForm/>} /> */}
          {/* <Route path="/other" element={<BrandSlider />} /> */}
          {/* <Route path="/other" element={<OurPriceViewDetails />} /> */}
          {/* <Route path="/rate-card" element={<RateCardPage />} /> */}
          
          {/* <Route path="/other" element={<OtherComponent />} /> */}

          <Route path="/app/policy" element={<AppPoliccy/>} />

          <Route path="/terms-of-service" element={<AppTermCondition/>} />
          
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
